const PREFIX = 'ACTIVATE_' as const;

export const ADD_DEVICE_TAG = `${PREFIX}ADD_DEVICE_TAG` as const;
export const REMOVE_DEVICE_TAG = `${PREFIX}REMOVE_DEVICE_TAG` as const;
export const CLEAR_STATE = `${PREFIX}CLEAR_STATE`;

export const GET_DEVICE_COUNT_REQUEST = `${PREFIX}GET_DEVICE_COUNT_REQUEST` as const;
export const GET_DEVICE_COUNT_SUCCESS = `${PREFIX}GET_DEVICE_COUNT_SUCCESS` as const;
export const GET_DEVICE_COUNT_ERROR = `${PREFIX}GET_DEVICE_COUNT_ERROR` as const;
